import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { LoanRequestsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};

export const schemaLoanRequestResolver_GetBucket = LoanRequestsTableDefinitionZod.shape.type;

export type SchemaLoanRequestResolver_GetBucket = z.infer<typeof schemaLoanRequestResolver_GetBucket>;

export type LoanRequestResolver_GetBucket = Resolver<Arguments, SchemaLoanRequestResolver_GetBucket>;
